import React from 'react';
import { FadeIn } from './FadeIn';
import { Check, X } from 'lucide-react';
export function Pricing() {
  const comparisons = [{
    name: 'Una sesión con psicólogo infantil',
    price: '$80 - $150 USD'
  }, {
    name: 'Un taller de crianza consciente',
    price: '$97 - $200 USD'
  }, {
    name: 'Un curso online de regulación emocional',
    price: '$47 - $97 USD'
  }];
  return <section id="pricing-section" className="w-full py-24 px-6 bg-white" data-id="element-221">
      <div className="max-w-4xl mx-auto" data-id="element-222">
        <FadeIn data-id="element-223">
          <div className="text-center mb-16" data-id="element-224">
            <h2 className="text-4xl md:text-5xl font-bold text-charcoal mb-6 font-serif" data-id="element-225">
              ¿Cuánto vale recuperar la paz en tu hogar?
            </h2>
            <p className="text-xl text-charcoal-light" data-id="element-226">Piénsalo así:</p>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-227">
          <div className="bg-cream rounded-3xl p-8 mb-16 border border-cream-dark" data-id="element-228">
            <div className="space-y-4 mb-8" data-id="element-229">
              {comparisons.map((item, index) => <div key={index} className="flex justify-between items-center p-4 bg-white rounded-xl text-charcoal-light opacity-70" data-id="element-230">
                  <span className="flex items-center gap-3" data-id="element-231">
                    <X className="w-5 h-5 text-gray-400" data-id="element-232" />
                    {item.name}
                  </span>
                  <span className="font-medium" data-id="element-233">{item.price}</span>
                </div>)}
            </div>

            <div className="flex justify-between items-center p-6 bg-terracotta text-white rounded-2xl shadow-lg transform scale-105" data-id="element-234">
              <span className="flex items-center gap-3 font-bold text-lg md:text-xl" data-id="element-235">
                <Check className="w-6 h-6 text-white" data-id="element-236" />
                Plan Cero Gritos Post-Pantalla
              </span>
              <span className="font-bold text-xl md:text-2xl line-through opacity-70" data-id="element-237">
                $27 USD
              </span>
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-238">
          <div className="text-center max-w-2xl mx-auto bg-white border-2 border-amber rounded-3xl p-10 shadow-xl relative" data-id="element-239">
            <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-amber text-charcoal font-bold px-6 py-2 rounded-full text-sm tracking-wider uppercase flex items-center gap-2 shadow-md" data-id="element-240">
              🔥 Oferta de Lanzamiento — Tiempo Limitado
            </div>

            <div className="mt-6 mb-8" data-id="element-241">
              <p className="text-gray-400 text-2xl line-through mb-2" data-id="element-242">
                $27.00 USD
              </p>
              <div className="flex justify-center items-baseline gap-2" data-id="element-243">
                <span className="text-2xl font-bold text-charcoal" data-id="element-244">
                  HOY SOLO:
                </span>
                <span className="text-6xl md:text-7xl font-bold text-terracotta font-serif" data-id="element-245">
                  $7.39
                </span>
                <span className="text-xl font-bold text-terracotta" data-id="element-246">USD</span>
              </div>
            </div>

            <ul className="space-y-3 mb-10 text-charcoal-light font-medium" data-id="element-247">
              <li className="flex items-center justify-center gap-2" data-id="element-248">
                <Check className="w-5 h-5 text-sage-dark" data-id="element-249" /> Acceso inmediato
              </li>
              <li className="flex items-center justify-center gap-2" data-id="element-250">
                <Check className="w-5 h-5 text-sage-dark" data-id="element-251" /> Descarga
                instantánea
              </li>
              <li className="flex items-center justify-center gap-2" data-id="element-252">
                <Check className="w-5 h-5 text-sage-dark" data-id="element-253" /> Sin suscripciones
              </li>
            </ul>

            <div className="bg-cream-dark/50 p-6 rounded-2xl text-left" data-id="element-254">
              <p className="text-charcoal font-medium flex gap-3 items-start" data-id="element-255">
                <span className="text-2xl" data-id="element-256">🧮</span>
                <span data-id="element-257">
                  <strong data-id="element-258">Para que lo veas claro:</strong> $7.39 USD es menos
                  que un café con leche. Pero el resultado puede cambiar la
                  dinámica de tu hogar para siempre.
                </span>
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}